export default String.raw`
{% assign msg = include -%}
{% assign cookieFormat = 'config-message-{0}' -%}
{% assign cookieName = cookieFormat | Format : {{msg.Id}}  -%}
{% if page.Cookies[cookieName] != 'hidden' or msgCounter == 1 -%}
	{% if msg.Type == 2 -%}
		<div class="notice-container-background message-popup-js {% if msgCounter == 1 -%} cookie-message-popup-js {% if page.Cookies[cookieName] == 'hidden' -%} hidden-js {% endif -%} {% endif -%}">
	{% endif -%}
            <div class="notice-container message-popup-js print-hidden {% if msg.Type == 0 -%} top-notice {% elseif msg.Type == 1 -%} bottom-notice {% else -%} popup-notice {% endif -%} {% if msgCounter == 1 and msg.Type != 2 -%} cookie-message-popup-js {% if page.Cookies[cookieName] == 'hidden' -%} hidden-js {% endif -%} {% endif -%}">
                {% if msgCounter != 1 -%}
                    <svg class="notice-container__close close-js prevent-cookie-message-js" data-name="{{ cookieName | H }}" data-days="{{ msg.Days }}">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                    </svg>
                {% endif -%}
                
                {% if msg.Title != '' -%}
                    {% if msg.Url != '' and msgCounter != 1 -%}
                        {% capture msgHref -%}{% include 'partials/common/user-link.html', userLink: msg.Url -%}{% endcapture -%}
                        <a href="{{ msgHref }}" class="notice-container__title">
                            {{ msg.Title }}
                        </a>
                    {% else -%}
                        <div class="notice-container__title">
                            {{ msg.Title }}
                        </div>
                    {% endif -%}
                {% endif -%}

                <div class="notice-container__message">{{ msg.Message }}</div>

                {% if msgCounter == 1 -%}
                    <div class="notice-container__btn-wrapper">
                        <button autofocus class="secondary-action-button notice-container__btn close-cookie-message-js open-cookie-popup-js">
                            {{translations.ChangeSettings}}
                        </button>
                        <button class="primary-action-button notice-container__btn accept-all-cookie-js close-cookie-message-js prevent-cookie-message-js" data-name="{{ cookieName | H }}" data-days="{{ msg.Days }}">
                            {{translations.AcceptAllSettings}}
                        </button>
                    </div>
                {% endif -%}
            </div>
	{% if msg.Type == 2 -%}
		</div>
	{% endif -%}

    {% if msgCounter == 1 -%}
        {% assign cookieConsentValue = page.Cookies['cookieSettings'] -%}
        {% assign cookieConsentValueArray = cookieConsentValue | Split: ',' -%}
        {% assign cookieConsentValueSize = cookieConsentValueArray | Size -%}

        <div class="cookie-container-background cookie-container-js hidden-js">
            <div class="cookie-container">
                <div class="cookie-container__title">
                    {{translations.CookieTitle}}
                </div>
                <div class="cookie-container__box">
                    <div class="cookie-container__paragraph">
                        {{translations.CookieText}}
                    </div>

                    <a href="{{ page.BaseHref }}{{ config.DefinedPages.Privacy.Url }}" target="_blank" rel="noopener noreferrer" class="cookie-container__link">
                        {{translations.CookiePrivacyPolicy}}
                    </a>

                    <div class="cookie-consent">
                        <div class="cookie-consent__wrapper">
                            <div class="cookie-consent__title">{{translations.CookieTitleOne}}</div>
                            <div class="cookie-consent__consent" data-value="granted"></div>
                        </div>
                        <div>{{translations.CookieDescriptionOne}}</div>
                    </div>

                    <div class="cookie-consent">
                        <div class="cookie-consent__wrapper">
                            <div class="cookie-consent__title">{{translations.CookieTitleTwo}}</div>
                            <div role="button" tabindex="0" class="cookie-consent__consent cookie-consent-js" 
                                data-value="{% if cookieConsentValueSize > 1 -%}{{cookieConsentValueArray[0]}}{% else -%}{{cookieConsentValue}}{% endif -%}" 
                                data-name="analytical"></div>
                        </div>
                        <div>{{translations.CookieDescriptionTwo}}</div>
                    </div>

                    <div class="cookie-consent">
                        <div class="cookie-consent__wrapper">
                            <div class="cookie-consent__title">{{translations.CookieTitleThree}}</div>
                            <div role="button" tabindex="0" class="cookie-consent__consent cookie-consent-js" 
                                data-value="{% if cookieConsentValueSize > 1 -%}{{cookieConsentValueArray[1]}}{% else -%}{{cookieConsentValue}}{% endif -%}" 
                                data-name="community"></div>
                        </div>
                        <div>{{translations.CookieDescriptionThree}}</div>
                    </div>

                    <div class="cookie-consent">
                        <div class="cookie-consent__wrapper">
                            <div class="cookie-consent__title">{{translations.CookieTitleFour}}</div>
                            <div role="button" tabindex="0" class="cookie-consent__consent cookie-consent-js" 
                                data-value="{% if cookieConsentValueSize > 1 -%}{{cookieConsentValueArray[2]}}{% else -%}{{cookieConsentValue}}{% endif -%}" 
                                data-name="advertising"></div>
                        </div>
                        <div>{{translations.CookieDescriptionFour}}</div>
                    </div>
                </div>
                <div class="cookie-container__btn-wrapper">
                    <button autofocus class="secondary-action-button cookie-container__btn save-custom-cookie-consents-js close-js prevent-cookie-message-js" 
                            data-name="{{ cookieName | H }}" 
                            data-days="{{ msg.Days }}"
                    >
                        {{translations.CookieAcceptOnlyChoose}}
                    </button>
                    <button class="primary-action-button cookie-container__btn accept-all-cookie-js close-js prevent-cookie-message-js" 
                            data-name="{{ cookieName | H }}" 
                            data-days="{{ msg.Days }}"
                    >
                        {{translations.CookieAcceptAll}}
                    </button>
                </div>
            </div>
        </div>
    {% endif -%}
{% endif -%}
`